import React from 'react';

import { VOID_FUNCTION } from 'constants/index';
import { useSwitcherPresenter } from './Switcher.presenter';
import * as S from './Switcher.styles';

export const Switcher = ({
  label,
  name,
  value = false,
  theme = 1,
  size = 'm',
  disabled = false,
  className,
  dataTest = '',
  onChange = VOID_FUNCTION,
}) => {
  const presenter = useSwitcherPresenter({ value, onChange });
  return (
    <S.Container
      className={className}
      dataTest={dataTest}
      disabled={disabled}
      theme={theme}
      size={size}
      checked={presenter.isChecked}
    >
      <S.Switcher>
        <S.Dot />
      </S.Switcher>
      {Boolean(label) && <S.Label>{label}</S.Label>}
      <S.InnerCheckbox
        ref={presenter.checkBoxRef}
        name={name}
        onChange={presenter.inputChangeHandler}
        disabled={disabled}
      />
    </S.Container>
  );
};
